export default __webpack_public_path__ + "static/blog-thumb-2-a45e3523f7d5e236320ebb2b22292e55.webp";